import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Organization: React.FC = () => {
  return <Outlet />;
};

export default Organization;
